import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const testimonials: [string, string, string][] = [['“Con Música Lista dejé de improvisar mis clases. Ya tengo todo el año organizado.”', 'Ana M.', 'Docente de Primaria'], ['“Los proyectos de armonía y composición engancharon muchísimo a mis alumnos.”', 'Carlos R.', 'Docente de Secundaria'], ['“Los bonos son un plus increíble, sobre todo el banco de canciones.”', 'Valeria S.', 'Docente de música']];
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-156" data-mp="141g3aktauem9">
      <Reveal className="mx-auto max-w-6xl" data-id="element-157" data-mp="142zjycivarok">
        <div className="mb-12 text-center" data-id="element-158" data-mp="1828az9miwbgf">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-159" data-mp="1831lmlolrl3u">
            ELEGIDO POR DOCENTES
          </p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-160" data-mp="32gsu3hv73yxp">
            Lo Que Dicen los Docentes de Música.
          </h2>
          <p className="mt-4 font-semibold text-brand-gray" data-id="element-161" data-mp="2v0j6lqwmu70b">
            ⭐⭐⭐⭐⭐ Pensado para enseñar música con confianza
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-162" data-mp="2q0n8g8am99so">
          {testimonials.map(([quote, name, role]) => <article key={name} className="flex min-h-[220px] flex-col rounded-2xl border border-brand-dark bg-brand-main p-7" data-id="element-163" data-mp="2zrregiibdkbd">
              <div className="flex gap-1" data-id="element-164" data-mp="2c4jjatelnrn2">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-165" data-mp="275zxct00afup" />)}
              </div>
              <p className="mt-5 flex-1 font-serif text-lg italic leading-relaxed" data-id="element-166" data-mp="1a5mp8oijv6v">{quote}</p>
              <div className="mt-6" data-id="element-167" data-mp="3sh8bxuksjreg">
                <p className="text-sm font-bold text-brand-blue" data-id="element-168" data-mp="3sg6r4ydz3qjj">{name}</p>
                <p className="text-xs text-brand-gray" data-id="element-169" data-mp="3fk3uct51cyd">{role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}